import { ref } from 'vue';
import {
    login as apiLogin,
    register as apiRegister,
    confirmEmail as apiConfirmEmail,
    resendCode as apiResendCode,
    changePassword as apiChangePassword,
    setUserInfo as apiSetUserInfo,
    getUserInfo as apiGetUserInfo,
    sendEmailLink as apiSendEmailLink,
    validResetToken as apiValidResetToken,
    isNonePassword as apiIsNonePassword,
    resetPassword as apiResetPassword, sendEmailLink, validResetToken, resetPassword,
} from '@/api/personal';
import {
    getToken as getApiTgToken,
    isTelegramConfirmed as isApiTelegramConfirmed
} from '@/api/telegram';

const token = ref(localStorage.getItem('token'));
const currentUser = ref(
    token.value
        ? JSON.parse(localStorage.getItem('user') || 'null')
        : null
);

export function usePersonal() {
    const tgToken = ref('');
    const tgIsConfirmed = ref(false);
    const tgError = ref('');
    
    async function login(email, password) {
        const { data } = await apiLogin(email, password);
        token.value = data.token;
        setUser(data);
        
        localStorage.setItem('token', data.token);
    }
    
    async function getTgToken() {
        try {
            const {data} = await getApiTgToken();
            tgToken.value = data.token;
        } catch (e) {
            tgError.value = 'Не удалось получить ссылку';
        }
    }
    
    async function isTelegramConfirmed() {
        try {
            const {data} = await isApiTelegramConfirmed();
            tgIsConfirmed.value = data === true;
        } catch (e) {
            tgIsConfirmed.value = false;
        }
    }
    
    function setUser(data) {
        currentUser.value = {
            email: data.email,
            role: data.role,
            firstName: data?.firstName ?? '',
            lastName: data?.lastName ?? '',
            phone: data?.phone ?? ''
        };
        localStorage.setItem('user', JSON.stringify(currentUser.value));
    }
    
    async function changePassword(password, newPassword) {
        const { data } = await apiChangePassword(password, newPassword);
    }
    
    async function setUserInfo(payload) {
        const { data } = await apiSetUserInfo(payload);
        setUser(data);
    }
    
    async function refreshUserInfo() {
        const { data } = await apiGetUserInfo();
        setUser(data);
    }
    
    async function register(email, password) {
        const { data } = await apiRegister(email, password);
    }
    
    async function isNonePassword() {
        const { data } = await apiIsNonePassword();
        return data === true;
    }
    
    async function confirmEmail(email, code) {
        const { data } = await apiConfirmEmail(email, code);
    }
    
    async function resendCode(email, code) {
        const { data } = await apiResendCode(email, code);
    }
    
    async function validResetToken(token) {
        const { data } = await apiValidResetToken(token);
        return data;
    }
    
    async function resetPassword(token, password) {
        const { data } = await apiResetPassword(token, { password });
    }
    
    async function sendEmailLink(email) {
        const { data } = await apiSendEmailLink({ email });
    }
    
    function logout() {
        token.value = null;
        currentUser.value = null;
        localStorage.removeItem('token');
        localStorage.removeItem('user');
    }
    
    return {
        token,
        tgToken,
        tgIsConfirmed,
        tgError,
        currentUser,
        resendCode,
        login,
        register,
        confirmEmail,
        logout,
        changePassword,
        setUserInfo,
        refreshUserInfo,
        isTelegramConfirmed,
        getTgToken,
        sendEmailLink,
        resetPassword,
        validResetToken,
        isNonePassword,
    };
}
